export type JsonPrimitive = string | number | boolean | null;
export type JsonValue = JsonPrimitive | JsonValue[] | { [key: string]: JsonValue };

export const RESOURCE_TYPES = [
  'progress',
  'training',
  'supplements',
  'chat-sessions',
  'settings',
  'cache'
] as const;

export type ResourceType = (typeof RESOURCE_TYPES)[number];

export const SYNCED_RESOURCE_TYPES = new Set<ResourceType>([
  'progress',
  'training',
  'supplements',
  'chat-sessions',
  'settings'
]);

export interface ResourceDocument {
  type: ResourceType;
  schemaVersion: number;
  localRevision: number;
  remoteVersion: number;
  updatedAt: string;
  payload: Record<string, JsonValue>;
}

export type SyncAction = 'set' | 'delete';

export interface SyncOperation {
  id: string;
  resourceType: ResourceType;
  documentKey: string;
  path: string[];
  action: SyncAction;
  value?: JsonValue;
  createdAt: string;
  localOrder: number;
}

export interface RemoteResource {
  payload: Record<string, JsonValue> | null;
  updatedAt: string | null;
  version: number;
}

export type RemoteResources = Partial<Record<ResourceType, RemoteResource>>;

export const LEGACY_KEY_TO_RESOURCE: Record<string, ResourceType> = {
  jidelnickovac_v1: 'progress',
  jidelnickovac_training_v1: 'training',
  jidelnickovac_supplements_v1: 'supplements',
  jidelnickovac_chat_sessions_v1: 'chat-sessions',
  jidelnickovac_dashboard_coach_v1: 'chat-sessions',
  jidelnickovac_model_v1: 'settings',
  jidelnickovac_theme: 'settings',
  jidelnickovac_today_axis_v1: 'settings',
  jidelnickovac_user_nickname: 'settings',
  jidelnickovac_user_name: 'settings',
  jidelnickovac_display_name: 'settings',
  jidelnickovac_chat_sessions_v1_backup: 'cache',
  jidelnickovac_dash_ai_macro_summary_v2: 'cache'
};

export const LEGACY_MANAGED_KEYS = Object.freeze(Object.keys(LEGACY_KEY_TO_RESOURCE));

export function isResourceType(value: string): value is ResourceType {
  return (RESOURCE_TYPES as readonly string[]).includes(value);
}

export function emptyResource(type: ResourceType): ResourceDocument {
  return {
    type,
    schemaVersion: 1,
    localRevision: 0,
    remoteVersion: 0,
    updatedAt: new Date(0).toISOString(),
    payload: {}
  };
}
